import React from "react";
import { ToastContainer } from "react-toastify";

import SettingsOffersDetails from "./components/SettingsOffersDetails";

const SettingsOffersDetailsApp = (props) => {
  return (
    <>
      <ToastContainer icon={false} />
      <SettingsOffersDetails {...props} />
    </>
  );
};

export default SettingsOffersDetailsApp;
